import { ToastController, AlertController } from 'ionic-angular';
import { NavController, App, ViewController } from 'ionic-angular';
import { LoginPage } from './login/login';
import { HomePage } from './home/home';
import { ErrorResult } from '../entities/errorResult';
import { LocalStorageService } from '../providers/localstorage';
import { CurrentUser, Ticket } from '../entities/currentUser';
import { OnInit } from '@angular/core';
import { Championship } from '../entities/championship';
import { Variables } from '../providers/variables';
import { UserService } from '../providers/user';
import { DateInfo } from '../entities/dateInfo';
import { LastLogin } from '../entities/lastLogin';
import { Message } from '../entities/message';


export { NavController, ToastController, ErrorResult, LocalStorageService, App, ViewController, AlertController, UserService };

declare var isMobile;

class Guid {
    static newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    }
}

export abstract class MainPage implements OnInit {

    private championships: Championship[];
    public currentUser: CurrentUser;
    public Title: string = "Bolão da Geral";
    private static AvaliableTickets: Ticket[];
    private static SelectedChampionship: Championship;
    private static SelectedTicket: Ticket;

    constructor(protected navCtrl: NavController, protected toastCtrl: ToastController, 
        protected localStorage: LocalStorageService, protected alertController: AlertController,
        protected userService: UserService,
        protected appCtrl: App) {
        this.currentUser = new CurrentUser();
        this.checkPermission();
        this.loadInfo();
        //this.loadPage();
    }

    public abstract loadPage(): void;

    go(Page: any) {
        this.appCtrl.getRootNav().push(Page, { guid: this.newGuid() });
    }

    saveUser(): void {
        this.localStorage.setItem("user", JSON.stringify(this.currentUser));
    };

    loadInfo(): void {
        this.championships = JSON.parse(this.localStorage.getItem("championships"));
        if (this.isNull(this.CurrentChampionship)) {
            for(var i=0; i<this.championships.length; i++) {
                if (this.championships[i].IsDefault) {
                this.CurrentChampionship = this.championships[i];
                break;
                }
            }
        }
    };

    newGuid(): string {
        return Guid.newGuid();
    }

    isNull(object: any): boolean {
        return(object == null) || (object == undefined);
    }

    get CurrentTicket():Ticket {
        if ((!this.isNull(MainPage.SelectedTicket)) && (MainPage.SelectedTicket.TicketId > 0)) {
            Variables.ticketId = MainPage.SelectedTicket.TicketId;
        }
        return MainPage.SelectedTicket;
    }
    
    set CurrentTicket(newSelectedTicket: Ticket) {
        MainPage.SelectedTicket = newSelectedTicket;
        Variables.ticketId = newSelectedTicket.TicketId;
        this.showMessages();
        this.loadPage();
    }

    get CurrentChampionship():Championship {
        return MainPage.SelectedChampionship;
    }

    get Tickets(): Ticket[] {
        return MainPage.AvaliableTickets;
    }

    public FormatDate(dateStr: string): DateInfo {
        return new DateInfo(dateStr);
    }

    get baseUrl(): string {
        return Variables.baseUrl;
    }

    public reloadTickets(): void {
        this.currentUser = JSON.parse(this.localStorage.getItem("user"));
        MainPage.AvaliableTickets = [];
        for(var i=0; i<this.currentUser.User.Tickets.length; i++){
            if (this.currentUser.User.Tickets[i].ChampionshipId == Variables.championshipId) {
                MainPage.AvaliableTickets.push(this.currentUser.User.Tickets[i]);
            }
        }
        if((MainPage.AvaliableTickets.length > 0) && ((MainPage.SelectedTicket == null) || (MainPage.SelectedTicket == undefined))) {
            this.CurrentTicket = MainPage.AvaliableTickets[0];
        }
    }
    
    set CurrentChampionship(newChampionship: Championship) {
        MainPage.SelectedChampionship = newChampionship;
        Variables.championshipId = newChampionship.ChampionshipId;
        this.reloadTickets();
        this.loadPage();
    }

    compareChampionship(c1: Championship, c2: Championship): boolean {
        return c1 && c2 ? c1.ChampionshipId === c2.ChampionshipId : c1 === c2;
    }

    compareTicket(c1: Ticket, c2: Ticket): boolean {
        return c1 && c2 ? c1.TicketId === c2.TicketId : c1 === c2;
    }

    showChampionship() {
        this.presentToast(MainPage.SelectedChampionship.Name);
    }
    /*setChampionship(newChampionship: Championship) {
        MainPage.SelectedChampionship = newChampionship;
        alert(MainPage.SelectedChampionship.Name);
    }*/

    getTitle(complement: string = "") {
        return this.Title + ' ' + complement + ' v' + Variables.version;
    }

    ngOnInit() {
        this.checkPermission();//alert('1');
    }

    checkPermission() {
        this.currentUser = JSON.parse(this.localStorage.getItem("user"));
        if (!this.isUserLoaded()) {
            this.logout(true);
        }

        this.reloadTickets();
    }

    isUserLoaded(): boolean {
        return ((null != this.currentUser) && (this.currentUser.User.LoginId > 0));
    }

    presentToast(message: string) {
        const toast = this.toastCtrl.create({
          message: message,
          duration: 10000,
          showCloseButton: true,
          closeButtonText: "Ok",
          position: 'middle'
        });
        toast.present();
    };

    removeMessage(message: Message, deleteMessage: boolean) {
        if (!this.isNull(this.CurrentTicket.Messages)) {
            for (var i=0; i<this.CurrentTicket.Messages.length; i++) {
                if (this.CurrentTicket.Messages[i].MessageId === message.MessageId) {
                    this.CurrentTicket.Messages.slice(i, 1);
                    break;
                }
            }
        }
        if (deleteMessage) {
            this.userService.cancelMessage(message.MessageId)
            .then((data: string) => {
                //this.presentToast(data)
            })
            .catch((err) => {
                this.getError(<ErrorResult>err);
              }); ;
        }
    }

    showMessages(): void {
        if ((!this.isNull(this.CurrentTicket.Messages)) && (this.CurrentTicket.Messages.length > 0)) {
            var currentMessage = this.CurrentTicket.Messages.pop();
            this.presentMessage(currentMessage);
        }
    }

    presentMessage(myMessage: Message) {
        let alert = this.alertController.create({
          title: myMessage.Title,
          message: myMessage.Text,
          buttons: [
            {
              text: 'Ok',
              role: 'ok',
              handler: data => {
                this.removeMessage(myMessage, false);
                this.showMessages();
              }
            },
            {
                text: 'Não mostrar mais',
                role: 'cancel',
                handler: data => {
                  this.removeMessage(myMessage, true);
                  this.showMessages();
                }
              }
          ]
        });
        alert.present();
      }

    logout(showMessage: boolean, clearPassword: boolean = true) {
        this.localStorage.removeItem("user");
        this.localStorage.removeItem("championships");
        MainPage.AvaliableTickets = [];
        MainPage.SelectedChampionship = null;
        MainPage.SelectedTicket = null;
        var lastLogin: LastLogin = <LastLogin>JSON.parse(this.localStorage.getItem("lastLogin"));
        if ((null != lastLogin) && (undefined != lastLogin) && (clearPassword)) {
            lastLogin.Password = "";
            this.localStorage.setItem("lastLogin", JSON.stringify(lastLogin));
        }
        if (showMessage) {
            this.presentToast("Sua sessão expirou e será necessária uma nova autenticação!");
        }
        this.navCtrl.setRoot(LoginPage);
    }

    goHome() {
        this.navCtrl.setRoot(HomePage);
    }

    getError(error: ErrorResult) {
        if (error.Status == "invalid_token") {
            this.logout(true, false);
        }
        else {
            this.presentToast(error.Message);
        }
    }

    get isAdmin(): boolean {
        return this.currentUser.User.Roles.indexOf("admin") >= 0;
    }

    get isMobile(): boolean {
        return isMobile.any();
    }
}


// WEBPACK FOOTER //
// ./src/pages/mainpage.ts